import React from 'react';
import { Image, Text, View } from 'react-native';
import { getRegularFont } from '../../utils/Utils';
import {
  img_check, img_collapse, img_expand, img_expanded,
} from '../../utils/ImagesManagementUtils';
import Avatar from './Avatar';
import { textPrimary_11_0, textSecondary_7_5 } from '../SimulatorsComponents/AuxiliaryComponent/TextComponent/TextStyle';
import { getDefaultGlobJSON } from '../../defaultConfigurations/MainConfigurations';

//= ========================================================================

const MyContactLine = ({
  globJSON,
  txtInitials,
  txtPrimary,
  txtSecondary,
  withAvatar,
  withExpand,
  withCollapse,
  avatarColor,
  showTheme = true,
  simPlatform,
  withExitButton = false,
  emptyBackground = false,
  selectedContact = false,
  withCircle = false,
}) => {
  //----------------------------------------------------------
  const circleSize = 15;
  const { colors } = showTheme ? globJSON.configurations.theme : getDefaultGlobJSON().configurations.theme;
  const { app_background_color } = colors;
  const { border_light_color } = colors;
  const { tertiary_icons_color } = colors;
  const myStyles = {
    selectedCircle: {
      borderRadius: circleSize,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      width: circleSize,
      height: circleSize,
      border: emptyBackground || (!selectedContact && (!withExpand && !withCollapse)) ? `solid 0.6px ${colors.border_color}` : 'none',
      backgroundColor: selectedContact ? colors.positive_color : '#fff',
      marginLeft: 0,
      marginTop: 10,
    },
    secondaryTxtStyle: {
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
    },
    breakLine: {
      width: 240,
      height: 1,
      position: 'absolute',
      backgroundColor: border_light_color,
    },
    imgExpanded: {
      width: 14,
      height: 14,
      marginLeft: 215,
      marginTop: 12,
      tintColor: tertiary_icons_color,
    },
    imgCollapse: {
      width: 14,
      height: 14,
      marginLeft: 215,
      marginTop: 12,
      tintColor: tertiary_icons_color,
    },
    imgCheck: {
      width: 13,
      height: 13,
    },
    avatarMargin: {
      marginLeft: 7,
      marginTop: 6,
    },
    textContainer: {
      width: 100,
      height: 14,
      marginLeft: 5,
    },
    container: {
      width: 240,
      height: 34,
      backgroundColor: app_background_color,
    },
    containerLeft: {
      width: 240,
      height: 34,
      position: 'absolute',
      backgroundColor: app_background_color,
      flexDirection: 'row',
      paddingStart: 5,
    },
  };

  return (
    <View style={myStyles.container}>
      <View style={myStyles.containerLeft}>
        {withAvatar ? (
          <Avatar
            globJSON={globJSON}
            simPlatform={simPlatform}
            txtInitials={!emptyBackground && txtInitials}
            style={myStyles.avatarMargin}
            the_avatar_bg_color={avatarColor}
            the_avatar_fn_color="#fff"
            withExitButton={withExitButton}
            emptyBackground={emptyBackground}
            selectedContact={selectedContact}
          />
        ) : (
          withCircle
            && (
              <View style={myStyles.selectedCircle}>
                { selectedContact && (
                  <Image
                    fadeDuration={0}
                    style={myStyles.imgCheck}
                    source={img_check}
                  />
                )}
              </View>
            ))}
        {avatarColor === '#fff' && !withAvatar }
        <View style={myStyles.textContainer}>
          <Text style={[textPrimary_11_0(globJSON, simPlatform), { marginTop: txtSecondary ? 6 : 11 }]}>{txtPrimary}</Text>
          <Text style={[textSecondary_7_5(globJSON, simPlatform), myStyles.secondaryTxtStyle]}>{txtSecondary}</Text>
        </View>
      </View>
      {withExpand && (
        <Image
          fadeDuration={0}
          style={myStyles.imgCollapse}
          source={img_collapse}
        />
      )}
      {withCollapse && (
        <Image
          fadeDuration={0}
          style={myStyles.imgExpanded}
          source={img_expanded}
        />
      )}
      <View style={myStyles.breakLine} />
    </View>
  );
};

export default MyContactLine;
